import api from './index'

/**
 * 创建微信支付订单
 * @param {Object} data 订单数据
 * @param {string} data.description 商品描述
 * @param {number} data.amount 金额（单位：分）
 * @param {number} data.userId 用户 ID
 * @param {string} data.attach 附加数据
 * @param {number} data.expireMinutes 订单过期时间（分钟）
 * @returns {Promise}
 */
export const createPayment = (data) => {
  return api.post('/api/payment/native/create', {
    description: data.description,
    amount: data.amount,
    userId: data.userId,
    attach: data.attach || '',
    expireMinutes: data.expireMinutes || 30
  })
}

/**
 * 查询支付状态
 * @param {string} orderNo 订单号
 * @returns {Promise}
 */
export const getPaymentStatus = (orderNo) => {
  return api.get(`/api/payment/native/status/${orderNo}`)
}

/**
 * 关闭支付订单
 * @param {string} orderNo 订单号
 * @returns {Promise}
 */
export const closePayment = (orderNo) => {
  return api.post('/api/payment/native/close', { orderNo })
}

/**
 * 获取用户订单列表
 * @param {Object} params 查询参数
 * @param {number} params.page 页码
 * @param {number} params.limit 每页数量
 * @param {string} params.status 状态筛选
 * @returns {Promise}
 */
export const getOrders = (params = {}) => {
  return api.get('/api/payment/orders', { params })
}

/**
 * 测试支付接口（开发环境）
 * @param {Object} data 测试数据
 * @param {string} data.description 商品描述
 * @param {number} data.amount 支付金额（分）
 * @returns {Promise}
 */
export const testPayment = (data) => {
  return api.post('/api/payment/native/test', data)
}
